import MainView from './MainView'
import ProfileView from './ProfileView'
import ProjectsView from './ProjectsView'
import NewProjectView from './NewProjectView'
import DevelopView from './DevelopView'
import SettingsView from './SettingsView'
import DonationView from './DonationView'
import AdminView from './AdminView'
import EditorView from './EditorView'
import LoginView from './LoginView'
import RegisterView from './RegisterView'
import EditorUserView from './EditorUserView'
import EditorTemplateView from './EditorTemplateView'
import EditorOverviewView from './EditorOverviewView'

const views = {
	MainView,
	ProfileView,
	ProjectsView,
	NewProjectView,
	DevelopView,
	SettingsView,
	DonationView,
	AdminView,
	EditorView,
	LoginView,
	RegisterView,
	EditorTemplateView,
	EditorOverviewView,
	EditorUserView
}

export default views